import React, { useMemo, useState } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import PageLayout from '../components/ui/PageLayout';
import ClientRequestList from '../components/client-requests/ClientRequestList';
import ClientRequestDetail from '../components/client-requests/ClientRequestDetail';
import CreateRequestDialog from '../components/client-requests/CreateRequestDialog';

export default function ClientRequestsPage() {
  const { requestId } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [createOpen, setCreateOpen] = useState(false);

  const initialStatuses = useMemo(() => {
    const s = searchParams.get('status');
    if (!s) return [];
    return s.split(',').map((x) => x.trim()).filter(Boolean);
  }, [searchParams]);

  const dueAfter = searchParams.get('due_after') || '';
  const dueBefore = searchParams.get('due_before') || '';
  const filterClientId = searchParams.get('client') ? Number(searchParams.get('client')) : undefined;

  if (requestId) {
    return (
      <PageLayout>
        <Box sx={{ maxWidth: 900, mx: 'auto' }}>
          <ClientRequestDetail requestId={requestId} onBack={() => navigate('/client-requests')} />
        </Box>
      </PageLayout>
    );
  }

  return (
    <PageLayout>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, flexWrap: 'wrap', gap: 2 }}>
        <Typography variant="h5" sx={{ fontWeight: 700 }}>
          Client Requests
        </Typography>
        <Button variant="contained" startIcon={<AddIcon />} onClick={() => setCreateOpen(true)} size="small">
          New Request
        </Button>
      </Box>
      <ClientRequestList
        initialStatuses={initialStatuses}
        dueAfter={dueAfter}
        dueBefore={dueBefore}
        filterClientId={filterClientId}
        onNew={() => setCreateOpen(true)}
      />
      <CreateRequestDialog open={createOpen} onClose={() => setCreateOpen(false)} onCreated={() => setCreateOpen(false)} />
    </PageLayout>
  );
}
